import { modules } from "byzantine";
import { AlertConfigurableField } from "byzantine/src/dbbl/businessLogic/modules/alerts";

import * as formAdapters from "../../../../../src/adapters";
import MultiAccountSelect from "../../../../MultiAccountSelect";

interface SubscribedAccountsFieldProps {
  alertKey: API.AlertKey;
  option: AlertConfigurableField;
}

const SubscribedAccountsField = ({
  alertKey,
  option,
}: SubscribedAccountsFieldProps) => {
  const form = modules.alerts.useAlertFormFromKey(alertKey);
  const eligibleAccounts = modules.alerts.useEligibleAlertAccounts();

  const {
    onChange: subscribedAccountsOnChange,
    value: subscribedAccounts,
    ...subscribedAccountsProps
  } = formAdapters.fieldWithOnChange(form, option.fieldName as any);

  return (
    <MultiAccountSelect
      accounts={eligibleAccounts}
      selectedAccountIds={subscribedAccounts}
      onSelectionChange={
        subscribedAccountsOnChange as unknown as (ids: string[]) => string[]
      }
      {...subscribedAccountsProps}
      id={alertKey}
    />
  );
};

export default SubscribedAccountsField;
